var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0587 6.02L12.9787 6.94L3.91875 16H2.99875V15.08L12.0587 6.02ZM15.6587 0C15.4087 0 15.1487 0.1 14.9587 0.29L13.1287 2.12L16.8787 5.87L18.7087 4.04C19.0987 3.65 19.0987 3.02 18.7087 2.63L16.3687 0.29C16.1687 0.09 15.9187 0 15.6587 0ZM12.0587 3.19L0.998749 14.25V18H4.74875L15.8087 6.94L12.0587 3.19Z",
    fill: "#2A272E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.7159951e0ce694806bd8200079d599d3.svg";
export { ForwardRef as ReactComponent };